<app-work-view
  [showFilter]="['user', 'position']"
  [projectId]="projectId"
  [positionId]="positionId"
></app-work-view>
